import { render, staticRenderFns } from "./DAS.vue?vue&type=template&id=3b8e274b&"
import script from "./DAS.vue?vue&type=script&lang=js&"
export * from "./DAS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports